import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ProtectedAuthRoutes } from '@/router/ProtectedAuthRoutes';
import { AppLayout } from '@/layouts/AppLayout/AppLayout';
import { WrapperLoading } from '@/router/WrapperLoading';

import { createRoute } from '@/router/utils/createRoute';
import type { RouteConfig } from '@/router/route.types';
import { PAGES } from '@/router/routeInitial.state';
import { INITIAL_PATH } from '@/constants';

import ACCESSORIAL_CHARGES_ROUTES from '@features/AccessorialCharges/AccessorialCharges.router';
import FREIGHT_BILL_ROUTES from '@features/FreightBill/FreightBill.router';
import DASHBOARD_ROUTES from '@features/Dashboard/Dashboard.router';
import RATE_ROUTES from '@features/Rate/Rate.router';

const ApiClientsPage = lazy(() => import('@/pages/ApiClients/ApiClientsPage'));
const GenericPage = lazy(() => import('@/pages/Generic/GenericPage'));

export const ROUTE_REGISTRY: Record<keyof typeof PAGES, RouteConfig> = {
  API_CLIENTS: {
    id: PAGES.API_CLIENTS.id,
    name: PAGES.API_CLIENTS.name,
    path: PAGES.API_CLIENTS.path,
    component: ApiClientsPage,
  },
  ...FREIGHT_BILL_ROUTES.ROUTES,
  ...DASHBOARD_ROUTES.ROUTES,
  ...RATE_ROUTES.ROUTES,
  ...ACCESSORIAL_CHARGES_ROUTES.ROUTES,
};

export const AppMainRoutes: RouteObject = {
  path: INITIAL_PATH || '/',
  element: (
    <ProtectedAuthRoutes>
      <AppLayout />
    </ProtectedAuthRoutes>
  ),
  children: [],
};

export const AppRoutes: RouteObject[] = Object.values(ROUTE_REGISTRY).map(createRoute);

export const getAppRoute = (path: string): RouteObject | undefined => {
  const found = AppRoutes.find((c) => c.path?.endsWith(path));
  if (found) return found;

  const newDynamicRoute = {
    id: path,
    path: path,
    element: (
      <WrapperLoading>
        <GenericPage />
      </WrapperLoading>
    ),
  };
  return newDynamicRoute;
};
